import { createSlice } from '@reduxjs/toolkit';

const hospitalSlice = createSlice({
    name: 'hospital',
    initialState: {
        loading: false,
        contacts: [],
        documents: [],
        categories: {
            contacts: [],
            documents: []
        },
        error: null,
        isContactCreated: false,
        isContactUpdated: false,
        isContactDeleted: false,
        isDocCreated: false,
        isDocDeleted: false,
        isCategoryCreated: false,
        isCategoryDeleted: false,
    },
    reducers: {
        hospitalRequest(state) {
            state.loading = true;
            state.error = null;
        },
        hospitalDataSuccess(state, action) {
            state.loading = false;
            state.contacts = action.payload.contacts || [];
            state.documents = action.payload.documents || [];
            if (action.payload.categories) {
                state.categories = {
                    contacts: action.payload.categories.contacts || [],
                    documents: action.payload.categories.documents || []
                };
            }
        },
        contactCreateSuccess(state, action) {
            state.loading = false;
            state.contacts = [...state.contacts, action.payload];
            state.isContactCreated = true;
        },
        contactUpdateSuccess(state, action) {
            state.loading = false;
            state.contacts = state.contacts.map(c =>
                c._id === action.payload._id || c.id === action.payload.id ? action.payload : c
            );
            state.isContactUpdated = true;
        },
        contactDeleteSuccess(state, action) {
            state.loading = false;
            state.contacts = state.contacts.filter(c => c._id !== action.payload && c.id !== action.payload);
            state.isContactDeleted = true;
        },
        docCreateSuccess(state, action) {
            state.loading = false;
            state.documents = [action.payload, ...state.documents];
            state.isDocCreated = true;
        },
        docDeleteSuccess(state, action) {
            state.loading = false;
            state.documents = state.documents.filter(d => d._id !== action.payload && d.id !== action.payload);
            state.isDocDeleted = true;
        },
        categoryCreateSuccess(state, action) {
            state.loading = false;
            const cat = action.payload;
            if (cat.type === 'contact') {
                state.categories.contacts = [...state.categories.contacts, cat];
            } else if (cat.type === 'document') {
                state.categories.documents = [...state.categories.documents, cat];
            }
            state.isCategoryCreated = true;
        },
        categoryDeleteSuccess(state, action) {
            state.loading = false;
            const id = action.payload;
            state.categories.contacts = state.categories.contacts.filter(c => c.id !== id && c._id !== id);
            state.categories.documents = state.categories.documents.filter(d => d.id !== id && d._id !== id);
            state.isCategoryDeleted = true;
        },
        hospitalFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        clearHospitalError(state) { state.error = null; },
        clearContactCreated(state) { state.isContactCreated = false; },
        clearContactUpdated(state) { state.isContactUpdated = false; },
        clearContactDeleted(state) { state.isContactDeleted = false; },
        clearDocCreated(state) { state.isDocCreated = false; },
        clearDocDeleted(state) { state.isDocDeleted = false; },
        clearCategoryCreated(state) { state.isCategoryCreated = false; },
        clearCategoryDeleted(state) { state.isCategoryDeleted = false; },
    },
});

export const {
    hospitalRequest,
    hospitalDataSuccess,
    contactCreateSuccess,
    contactUpdateSuccess,
    contactDeleteSuccess,
    docCreateSuccess,
    docDeleteSuccess,
    categoryCreateSuccess,
    categoryDeleteSuccess,
    hospitalFail,
    clearHospitalError,
    clearContactCreated,
    clearContactUpdated,
    clearContactDeleted,
    clearDocCreated,
    clearDocDeleted,
    clearCategoryCreated,
    clearCategoryDeleted,
} = hospitalSlice.actions;

export default hospitalSlice.reducer;
